module.exports = __webpack_public_path__ + "img/downImage.31998a78.svg";